import axios from "axios";
import API_URL from "../constants/api_url";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ Attach token to every request (skip for public routes)
api.interceptors.request.use(
  (config) => {
    const isPublicRoute = window.location.pathname.startsWith("/public/");
    const token = localStorage.getItem("token");
    if (token && !isPublicRoute) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Redirect to login on 401 (skip for public routes and login request)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isPublicRoute = window.location.pathname.startsWith("/public/");
    const isLoginPage = window.location.pathname.includes("/login");
    const isLoginRequest = error.config?.url === "/auth/login";

    if (
      error.response?.status === 401 &&
      !isPublicRoute &&
      !isLoginPage &&
      !isLoginRequest
    ) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;